export default "__VITE_ASSET__BIaynR7j__"